import React, { useEffect, useState } from "react";
import "./EditarMeusDados.css";

function EditarMeusDados() {
    const [formData, setFormData] = useState({
        id: "",
        nome: "",
        nome_empresa: "",
        logo: "",
        responsavel: "",
        telefone: "",
        logradouro: "",
        cidade: "",
        cep: "",
        email: "",
        cpf_cnpj: ""
    });

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchDadosUsuario();
    }, []);

    const fetchDadosUsuario = async () => {
        try {
            const response = await fetch("https://welaunchyou.com.br/crm-wly/editar_meus_dados.php", {
                credentials: "include",
            });

            const data = await response.json();

            if (response.ok) {
                setFormData(data.usuario);
            } else {
                setError(data.error || "Erro ao carregar dados do usuário.");
            }
        } catch (err) {
            setError("Erro ao conectar ao servidor.");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        setError("");

        try {
            const response = await fetch("https://welaunchyou.com.br/crm-wly/editar_meus_dados.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage("Dados atualizados com sucesso!");
            } else {
                setError(data.error || "Erro ao atualizar dados.");
            }
        } catch (err) {
            setError("Erro ao conectar ao servidor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="dados-titutlo">
        <h1>Editar Meus Dados</h1>
        <div className="meus-dados-container">
            <div className="editar-dados-container">
                       {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}

                <form onSubmit={handleSubmit}>
                    {/* Campos não editáveis */}
                    <div className="form-group">
                        <label>ID:</label>
                        <input type="text" name="id" value={formData.id} readOnly />
                    </div>

                    <div className="form-group">
                        <label>Nome:</label>
                        <input type="text" name="nome" value={formData.nome} readOnly />
                    </div>

                    <div className="form-group">
                        <label>Nome da Empresa:</label>
                        <input type="text" name="nome_empresa" value={formData.nome_empresa} readOnly />
                    </div>

                    <div className="form-group">
    <label>CPF/CNPJ:</label>
    <input type="text" name="cpf_cnpj" value={formData.cpf_cnpj} readOnly />
</div>


                    {/* Exibição da logo */}
                    {formData.logo && (
    <div className="form-group">
        <label>Logo da Empresa:</label>
        <img
            src={`https://welaunchyou.com.br/crm-wly/${formData.logo.replace(/\\/g, '/')}`}
            alt="Logo da Empresa"
            className="meus-dados-logo"
        />
    </div>
)}


                    {/* Campos editáveis */}
                    <div className="form-group">
                        <label>Responsável:</label>
                        <input type="text" name="responsavel" value={formData.responsavel} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Telefone:</label>
                        <input type="text" name="telefone" value={formData.telefone} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Logradouro:</label>
                        <input type="text" name="logradouro" value={formData.logradouro} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Cidade:</label>
                        <input type="text" name="cidade" value={formData.cidade} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>CEP:</label>
                        <input type="text" name="cep" value={formData.cep} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Email:</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} />
                    </div>

                    <button className="btn-user" type="submit" disabled={loading}>
                        {loading ? "Salvando..." : "Salvar Alterações"}
                    </button>
                </form>
            </div>
        </div>
        </div>
    );
}

export default EditarMeusDados;
